// extracted by mini-css-extract-plugin
module.exports = {"CreditCardDisclosureGroup":"_1KTiK","creditCardDisclosureGroup":"_1KTiK"};